import React from "react";
import logo from "../../../assets/Picture.png";
import {
  Document,
  Page,
  StyleSheet,
  Image,
  Text,
  View,
  Svg,
} from "@react-pdf/renderer";
import { pdf } from "@react-pdf/renderer";
import JsBarcode from "jsbarcode";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 20,
  },
  layout: {
    padding: "2px 0",
  },

  logo: {
    width: 40,
    marginBottom: 20,
  },
  logo1: {
    width: "70%",
    marginBottom: 20,
  },
  barcodeImg: {
    width: 100,
    height: 50,
  },
  section: {
    flexDirection: "row",
    gap: 10,
    alignItems: "center",
    padding: 10,
  },

  section2: {
    width: "40%",
    flexDirection: "column",
    padding: 10,
  },

  section3: {
    width: "20%",
    flexDirection: "column",
    padding: 10,
  },
  section4: {
    width: "60%",
    flexDirection: "column",
    padding: 10,
  },

  box: {
    flexDirection: "column",
    padding: "10px 0",
  },
  title: {
    fontSize: 10,
    marginBottom: 5,
    font: "Arial",
    textTransform: "uppercase", // Capitalize text
    // fontWeight: 'bold',
  },
  title1: {
    width: "100%",
    fontSize: 12,
    padding: "0 10px ",
    textTransform: "uppercase",
    font: "Arial",
    fontWeight: "bold",
  },

  titleBox: {
    width: "100%",
    borderBottom: "1px solid gray",
    fontWeight: "bold",
    padding: "10px ",
  },

  text: {
    fontSize: "8px",
    marginBottom: 5,
  },
  valueBox: {
    fontSize: "10px",
    marginBottom: 5,
    width: "50%",
  },
  textBox: {
    flexDirection: "column",
    gap: 2,
    justifyContent: "space-between",
  },
  rowContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    // gap: 10,
    marginBottom: 10,
    borderBottom: "1px solid gray",
  },

  rowContainer1: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 10,
    marginBottom: 10,
    borderBottom: "1px solid gray",
  },

  rowBox: {
    flexDirection: "row",
    gap: 5,
    justifyContent: "space-between",
    padding: 3,
  },
});
// Generate a data URL barcode synchronously to avoid state/effect timing issues
const createBarcodeDataUrl = (value) => {
  try {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, String(value || ""), {
      format: "CODE128",
      width: 2,
      height: 100,
      displayValue: false,
      margin: 0,
    });
    return canvas.toDataURL("image/png");
  } catch (e) {
    // Fallback: no barcode
    return null;
  }
};

const PDFDocument = ({ formData, barcodeUrl }) => (
  <Document>
    <Page size="A5" style={styles.page} wrap>
      {formData && (
        <View style={styles.layout}>
          <View style={styles.rowContainer}>
            <View style={styles.section3}>
              <Image src={logo} style={styles.logo} />
            </View>

            <View style={styles.section2}>
              <View style={styles.titleBox}>
                <Text style={styles.title}>From : </Text>
                <Text style={styles.text}>{formData?.loadCountry} </Text>
              </View>
            </View>

            <View style={styles.section2}>
              <View style={styles.titleBox}>
                <Text style={styles.title}>To : </Text>
                <Text style={styles.text}>{formData?.unloadCountry} </Text>
              </View>
            </View>
          </View>

          <View style={styles.rowContainer1}>
            <View style={styles.section2}>
              <View style={styles.textBox}>
                <Text style={styles.title}>
                  ONE UNION SOLUTIONS REFERENCE:{" "}
                </Text>
                <Text style={styles.valueBox}>{formData?.orderNumber}</Text>
              </View>

              <View style={styles.textBox}>
                <Text style={styles.title}>CUSTOMER REFERENCE: </Text>
                <Text style={styles.valueBox}>
                  {formData?.loadAddress_ReferenceCustomer}
                </Text>
              </View>
            </View>
            <View style={styles.section2}>
              <View style={styles.textBox}>
                <Text style={styles.title}>Tracking Number: </Text>
                <Text style={styles.valueBox}>{formData?.trackingNumber}</Text>
              </View>
              {barcodeUrl ? (
                <Image style={styles.logo1} src={barcodeUrl} />
              ) : null}
            </View>
          </View>
          <Text style={styles.title1}>
            FRAGILE SHIPMENT, KINDLY HANDLE WITH CARE AND DO NOT DOUBLE STACK{" "}
          </Text>
        </View>
      )}
    </Page>
  </Document>
);
export const generateShipmentLabel = async (formData) => {
  const barcodeUrl = createBarcodeDataUrl(formData?.trackingNumber);
  return await pdf(<PDFDocument formData={formData} barcodeUrl={barcodeUrl} />).toBlob();
};
export default generateShipmentLabel;
